import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

/**
 * Preloading strategy that only preloads lazy routes explicitly flagged
 * with `data.preload === true`.
 *
 * Unlike `PreloadAllModules`, this keeps light modules on-demand and lets
 * us eagerly warm up only the heavy ones (e.g. onboarding), so the chunk
 * is already in memory by the time the user clicks the menu item and the
 * navigation feels instant instead of freezing while the chunk downloads.
 */
@Injectable({ providedIn: 'root' })
export class SelectivePreloadStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    return route.data?.['preload'] === true ? load() : of(null);
  }
}
